/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _maybeAddRowExpandColumn = _interopRequireDefault(require("./maybeAddRowExpandColumn"));
var _useRowDetails = _interopRequireDefault(require("./useRowDetails"));
var _default = {
  name: 'row-details',
  hook: _useRowDetails.default,
  maybeAddColumns: function maybeAddColumns(columns, props) {
    columns = (0, _maybeAddRowExpandColumn.default)(columns, props);
    return columns;
  },
  defaultProps: function defaultProps() {
    return {};
  }
};
exports.default = _default;